import React from 'react';
import { motion } from 'framer-motion';
import { Code2, Lightbulb, Users } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../hooks/useLang';
import Navbar from '../components/common/Navbar';
import '../styles/pages/Events.scss';

const EVENTS = [
    {
        category: 'Hackathon',
        icon: Code2,
        color: '#4f7c67',
        description: 'A weekend where student teams build real tools together and show what they made.',
    },
    {
        category: 'Workshop',
        icon: Lightbulb,
        color: '#2a6f9e',
        description: 'A guided session on study skills and exam preparation led by our top contributors.',
    },
    {
        category: 'Meetup',
        icon: Users,
        color: '#8a5cc4',
        description: 'A casual gathering for our most active members to meet the team in person.',
    },
];

const Events = () => {
    const { language } = useLang();
    const navigate = useNavigate();

    return (
        <div className="events-wrapper">
            <Navbar />

            <section className="events-hero">
                <motion.div
                    className="events-hero-text"
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7, ease: 'easeOut' }}
                >
                    <p className="events-breadcrumb">YeniDers &bull; Events</p>
                    <h1>Events</h1>
                    <p className="events-subtitle">
                        We are building experiences for students across Azerbaijan. Here is an early look
                        at what is coming.
                    </p>
                </motion.div>
            </section>

            <section className="events-grid-section">
                <div className="events-grid">
                    {EVENTS.map((event, index) => {
                        const Icon = event.icon;
                        return (
                            <motion.div
                                key={event.category}
                                className="event-card"
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.6, delay: index * 0.12, ease: 'easeOut' }}
                            >
                                <div
                                    className="event-banner"
                                    style={{ background: `linear-gradient(135deg, ${event.color}26, ${event.color}0a)` }}
                                >
                                    <span className="event-status">Coming Soon</span>
                                    <div className="event-icon-circle" style={{ background: event.color }}>
                                        <Icon size={26} color="#fff" strokeWidth={2} />
                                    </div>
                                </div>
                                <div className="event-body">
                                    <span className="event-category" style={{ color: event.color }}>{event.category}</span>
                                    <p>{event.description}</p>
                                </div>
                            </motion.div>
                        );
                    })}
                </div>

                <motion.button
                    className="events-cta"
                    onClick={() => navigate(`/${language}/signup`)}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.3, ease: 'easeOut' }}
                >
                    Create a Free Account
                </motion.button>
            </section>
        </div>
    );
};

export default Events;
